import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=9d4e77ae&"
import script from "./project-card.vue?vue&type=script&lang=ts&"
export * from "./project-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports